import React from 'react';
import createOpenGraphTags from '@repo/utils/createOpenGraphTags';
import Breadcrumb from '@components/breadcrumb';
import Layout from '@components/layout';
import BlogArticle from '@components/articles/BlogArticle';
import RecentArticles from '@components/articles/RecentArticles';
import { styles } from '@components/utils';
import KurgoContainer from '@components/utils/ContainerStyles';
import { ShopifyBlogPost } from '@repo/models/gatsby-graphql-types';

interface BreadcrumbElement {
  link?: string;
  text: string;
}

interface PageContextType {
  article: ShopifyBlogPost;
  breadcrumbs?: BreadcrumbElement[];
}

const ArticleDetail: React.FC<{ pageContext: PageContextType }> = ({
  pageContext,
}) => {
  const { article, breadcrumbs } = pageContext;

  const openGraphData = {
    type: 'article',
    title: `${article?.title} - Kurgo Dog Products`,
    description: article?.excerpt,
    url: `/blog/${article?.handle}`,
    image: article.image.url,
    article: {
      published_time: article?.publishedAt,
      author: article?.authorV2?.name,
      tag: article?.tags,
    },
  };

  return (
    <Layout
      headTagData={{
        title: `${article?.title} - Kurgo Dog Products`,
        description: article?.excerpt,
        meta: createOpenGraphTags(openGraphData, 'kurgo'),
      }}
    >
      <KurgoContainer backgroundColor={styles.colors.gray[100]}>
        {breadcrumbs && <Breadcrumb elements={breadcrumbs} />}
        <BlogArticle article={article} />
        <RecentArticles />
      </KurgoContainer>
    </Layout>
  );
};

export default ArticleDetail;
